import Cards from "../Cards";

const VideoCarousel = () => {
  const items = [
    [
      "vidsource1",
      "https://drive.google.com/file/d/1yWr7KideHIS-gxIdE4O11e2wjxwo8xFx/preview",
    ],
    [
      "vidsource2",
      "https://drive.google.com/file/d/1uMwzCzV6abvvSF955TVBCVvQ6-Y8B5FR/preview",
    ],
    [
      "vidsource3",
      "https://drive.google.com/file/d/1L4vV4uJ9unGnfFBSyxangj6fgToNZFJF/preview",
    ],
    [
      "vidsource4",
      "https://drive.google.com/file/d/1G6qdIxRPaAnpqGg3mPg1tbJKpx-l2UBO/preview",
    ],
    [
      "vidsource5",
      "https://drive.google.com/file/d/1CYLmRlYimDFI0MyRhk4f-uo7QVugGhWF/preview",
    ],
  ];
  return (
    <div className="flex flex-col gap-y-5 z-1 my-10 bg-bg-primary">
      <div className="flex flex-row text-lg justify-between">
        <h1 className="z-10 text-xs sm:text-sm md:text-sm lg:text-base xl:text-base italic font-bold">
          Short Form Videos
        </h1>
        <a href="https://drive.google.com/drive/folders/1n2UE4zxbVIVdY0vRZJRo0v30kFdXVe_W?usp=sharing">
          <div className="flex flex-row text-lg hover:text-accent ease-in-out duration-100">
            <p className="z-10 text-xs sm:text-sm md:text-sm lg:text-base xl:text-base">
              Click for more
            </p>
          </div>
        </a>
      </div>
      <div className="w-full sm:grid sm:grid-cols-2 sm:grid-rows-2 gap-5">
        {items.map(([key, s]) => (
          <Cards url={s} key={key} />
        ))}
      </div>
    </div>
  );
};

export default VideoCarousel;
